<div class="ui-g ui-fluid">
  <div class="ui-g-12 background" >
        <div class="ui-g-12">
          <h2 class="title">{{this.titleBenefit}}</h2>
          <h3 class="subTitle">{{this.subTitleBenefit}}</h3>
        </div>
  </div>
  <div class="ui-g-12  ui-lg-12 ui-fluid p-grid" *ngFor="let benefit of benefits; let i = index">
    <div class="ui-g-12" *ngIf="benefit.benefitGroup == 'Monto contratado'">
      <div class="ui-g-12">
        <h2 class="title2">{{benefit.benefitGroup}}</h2>
      </div>
      <div class="ui-g-12 ui-g ui-fluid" *ngFor="let detail of benefit.detail; let i = index">
          <div class="ui-g-6 ui-md-4 ui-lg-4">
                <p class="benefit" style="font-size: 16px; font-weight: bold;">{{detail.benefitCondition}}</p>
              </div>
              <div class="ui-g-6 ui-md-4 ui-lg-4 cardGray" style="padding: 7px !important;">
                <h2 class="status">{{detail.conditionValue}}</h2>
              </div>
              <div *ngIf="detail.conditionNotes != ''">
                <p >{{detail.conditionNotes}}</p>
              </div>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="benefit.benefitGroup == 'Participación Asegurado'">
      <div class="ui-g-12">
        <h2 class="title2">{{benefit.benefitGroup}}</h2>
      </div>
      <div class="ui-g-12 ui-g ui-fluid" *ngFor="let detail of benefit.detail; let i = index">
          <div class="ui-g-6 ui-md-4 ui-lg-4">
                <p class="benefit" style="font-size: 16px; font-weight: bold;">{{detail.benefitCondition}}</p>
              </div>
              <div class="ui-g-6 ui-md-4 ui-lg-4 cardGray" style="padding: 7px !important;">
                <h2 class="status">{{detail.conditionValue}}</h2>
              </div>
              <div *ngIf="detail.conditionNotes != ''">
                <p >{{detail.conditionNotes}}</p>
              </div>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="benefit.benefitGroup == 'Servicios Contratados'">
      <div class="ui-g-12">
        <h2 class="title2">{{benefit.benefitGroup}}</h2>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-3" *ngFor="let detail of benefit.detail; let i = index">
        <div class="cardGray" style="min-height: 225px">
          <div class="ui-g ui-fluid">
            <div class="ui-g-12">
              <div class="ui-g-12" style="display: flex; align-items: center;">
                <!--<img src="../../assets/images/benefits/consulta_externa.png" style="margin: 4px auto;">-->
                <img src="{{detail.nameIcon}}" style="margin: 4px auto;">
              </div>
              <div class="ui-g-9">
                <p class="benefit">{{detail.benefitCondition}}</p>
              </div>
              <div class="ui-g-3 bg">
                <h2 class="status">{{detail.conditionValue}}</h2>
              </div>
              <div *ngIf="detail.conditionNotes != ''">
                <p >{{detail.conditionNotes}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class="ui-g-12" *ngIf="benefit.benefitGroup == 'Maternidad'">
      <div class="ui-g-12 maternidad" *ngFor="let detail of benefit.detail; let i = index">
          <div class="ui-g ui-fluid">
            <div class="ui-g-12">
              <div class="ui-g-12 ui-md-4 ui-lg-4">
                <h2 class="title2" style="margin: 0;">{{benefit.benefitGroup}}</h2>
                <h3 class="benefit">{{detail.benefitCondition}}</h3>
                <div class="ui-g-12" *ngIf="detail.conditionNotes != ''">
                  <p >{{detail.conditionNotes}}</p>
                </div>
              </div>
              <div class="ui-g-12 ui-md-1 ui-lg-1 cardGray2">
                <h2 class="status">{{detail.conditionValue}}</h2>
              </div>
            </div>
          </div>
       
      </div>
    </div>
  </div>
</div>
<!--

<div class="layout-content">
  <ul class="layout-menu">
    <li *ngFor="let benefit of benefits; let i = index">
      <a [routerLink]="['/home']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <i class="pi pi-fw pi-home"></i>
        <span>{{benefit.benefitGroup}}</span>
      </a>
      <ul class="layout-menu">
        <li *ngFor="let detail of benefit.detail; let i = index">
          <a [routerLink]="['/home']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <i class="pi pi-fw pi-home"></i>
            <span>{{detail.benefitCondition}}</span>
          </a>
          <br>
          <a [routerLink]="['/home']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <i class="pi pi-fw pi-home"></i>
            <span>{{detail.conditionValue}}</span>
          </a>
          <br>
          <a [routerLink]="['/home']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <i class="pi pi-fw pi-home"></i>
            <span>{{detail.conditionNotes}}</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>-->
